import { TextField, Skeleton } from "@mui/material";
import React from "react";

function CustomTextField({
  id,
  name,
  defaultValue,
  onMouseDown,
  placeholder,
  type,
  onChange,
  onBlur,
  value,
  error,
  helperText,
  inputProps,
  isDisabled,
  autoFocus,
  forcePositiveDecimal = false,

  // NEW
  isLoading = false,
}) {
  const ModifiedTextField = {
    "& .MuiOutlinedInput-root": {
      fontFamily: "Poppins",
      fontSize: "15px",
      "& fieldset": { borderColor: "#C0C0C0" },
      "&:hover fieldset": { borderColor: "#C0C0C0" },
      "&.Mui-focused fieldset": { borderColor: "#C0C0C0" },
    },
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: "#272727",
    },
  };

  const handleKeyDown = (e) => {
    if (!forcePositiveDecimal) return;

    if (["e", "E", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleInput = (e) => {
    if (!forcePositiveDecimal) return;

    let v = e.target.value;

    v = v.replace(/[^0-9.]/g, "");
    v = v.replace(/(\..*)\./, "$1");

    e.target.value = v;
  };

  // 🔥 NEW: return skeleton instead of TextField
  if (isLoading) {
    return (
      <Skeleton
        variant="rounded"
        height={40}
        sx={{ borderRadius: "6px" }}
      />
    );
  }

  return (
    <TextField
      autoFocus={autoFocus}
      id={id}
      disabled={isDisabled}
      className="modified_text_field"
      name={name}
      fullWidth
      autoComplete="off"
      size="small"
      defaultValue={defaultValue}
      placeholder={placeholder}
      type={type}
      onKeyDown={handleKeyDown}
      onInput={handleInput}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      error={error}
      helperText={helperText}
      FormHelperTextProps={{ style: { marginLeft: 0 } }}
      variant="outlined"
      sx={ModifiedTextField}
      InputProps={inputProps}
      onMouseDown={onMouseDown}
    />
  );
}

export default CustomTextField;
